import { render } from "./PropietariosComponent.vue?vue&type=template&id=493060fc&scoped=true"
import script from "./PropietariosComponent.vue?vue&type=script&lang=js"
export * from "./PropietariosComponent.vue?vue&type=script&lang=js"

import "./PropietariosComponent.vue?vue&type=style&index=0&id=493060fc&scoped=true&lang=css"

import exportComponent from "/Users/norberto/Documents/Marketing HL/adminmkthl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493060fc"]])

export default __exports__